<script setup lang="ts">
import Card from '@/Components/Ui/Card.vue';
import PublicLayout from '@/Layouts/PublicLayout.vue';
import { register } from '@/routes';
import { Head, useForm } from '@inertiajs/vue3';
import RegisterForm from './Partials/RegisterForm.vue';

const submit = (form: ReturnType<typeof useForm>) => {
    form.post(register().url, {
        onFinish: () => {
            form.reset();
        },
    });
};
</script>

<template>
    <PublicLayout>
        <Head :title="$t('auth.register.title')" />

        <Card class="w-full max-w-md" padding="lg">
            <h1
                class="font-display text-ink mb-6 text-2xl font-semibold tracking-[-0.01em]"
            >
                {{ $t('auth.register.title') }}
            </h1>

            <RegisterForm @submit="submit" />
        </Card>
    </PublicLayout>
</template>
